<!-- <div class="container-fluid title-bg py-3">
  <div class="container">
    <div class="d-flex align-items-center">
      <img src="assets/icon-image/Settings-title-img.svg" alt="image" />
      <h2 class="Settings-title ms-4 mt-2">Settings</h2>
    </div>
  </div>
</div> -->

<div class="container">
  <div class="setting-box d-flex mt-5 p-3">
    <div class="setting-nav-box me-2">
      <div class="py-2 Settings-tul-s-background-color">
        <div class="d-flex setting-nav-icon p-2 align-items-center" (click)="selectedTab = 'profile'">
          <img src="assets/icon-image/Settings-profile-icon-img.svg" alt="image" class="setting-nav-icon-size" />
          <h1 class="ms-3 mb-0 Settings-tul-s-bar-text-color align-items-center">Profile</h1>
        </div>
      </div>
      <div class="py-2 mt-1 Settings-tul-s-background-color">
        <div class="d-flex setting-nav-icon p-2 align-items-center"
          (click)="boardPiecemenushow();selectedTab = 'board';">
          <img src="assets/icon-image/Settings-board-and-pieces-icon.svg" alt="image" class="setting-nav-icon-size" />
          <h1 class="ms-3 mb-0 Settings-tul-s-bar-text-color">Board & Pieces</h1>
        </div>
      </div>
      <div class="py-2 mt-1 Settings-tul-s-background-color">
        <div class="d-flex setting-nav-icon p-2 align-items-center" (click)="selectedTab = 'themes'">
          <img src="assets/icon-image/Settings-themes-icon.svg" alt="image" class="setting-nav-icon-size" />
          <h1 class="ms-3 mb-0 Settings-tul-s-bar-text-color">Themes</h1>
        </div>
      </div>
      <div class="py-2 mt-1 Settings-tul-s-background-color">
        <div class="d-flex setting-nav-icon p-2 align-items-center" (click)="passwordShow();selectedTab = 'password'">
          <img src="assets/icon-image/Settings-Password-icon.svg" alt="image" class="setting-nav-icon-size" />
          <h1 class="ms-3 mb-0 Settings-tul-s-bar-text-color">Password</h1>
        </div>
      </div>
      <div class="py-2 mt-1 Settings-tul-s-background-color">
        <div class="d-flex setting-nav-icon p-2 align-items-center" (click)="selectedTab = 'forgetPassword'">
          <img src="assets/icon-image/forgot-password.png" alt="image" class="setting-nav-icon-size" />
          <h1 class="ms-3 mb-0 Settings-tul-s-bar-text-color">Forget Password</h1>
        </div>
      </div>
      <div class="py-2 mt-1 Settings-tul-s-background-color">
        <div class="d-flex setting-nav-icon p-2 align-items-center" (click)="friendList()">
          <img src="assets/icon-image/setting-friend-list.png" alt="image" class="setting-nav-icon-size" />
          <h1 class="ms-3 mb-0 Settings-tul-s-bar-text-color">Friend List</h1>
        </div>
      </div>
    </div>
    <div class="setting-nav-details">
      @if(selectedTab === 'profile'){
      <div>
        <div class="d-flex profile-section p-3">
          <div (mouseenter)="showeditlebal = true" style="position: relative" (mouseleave)="showeditlebal = false"
            class="d-flex align-items-center justify-content-center">
            @if (showeditlebal) {
            <label for="fileInput" class="upload-icon">
              <i class="fa-solid fa-pen" style="color: whitesmoke"></i>
            </label>
            <input type="file" id="fileInput" (change)="onFileSelected($event)" accept="image/*"
              style="display: none" />
            }
            <img
              [src]="profileUserData?.image ? profileImg : (selectedImage ? selectedImage : '/assets/customer-image/men-shadow.png')"
              class="img-upload rounded" style="width: 100px; height: 100px" alt="profile image" />
          </div>

          <div class="p-2 ms-3">
            <h3 class="profile-username" style="cursor: pointer; color: var(--default-font-color)"
              (click)="profilememberDetails(profileUserData?.username)">
              {{ profileUserData?.username }}
            </h3>

            <h5 class="profile-name">
              {{ (updateProfiledetail?.firstname ? updateProfiledetail.firstname : profileUserData?.firstname) }}
              {{ (updateProfiledetail?.lastname ? updateProfiledetail.lastname : profileUserData?.lastname) }}
            </h5>

            <div class="d-flex align-items-center mt-3">
              @if(statusinputShow == true){
              <input type="text" class="form-control statusinput" [(ngModel)]="statusValue"
                placeholder="Enter a Status here" maxlength="50" />
              <button style="
                  border: 1px solid var(--font-color);
                  color: var(--Settings-tul-s-bar-text-color);
                " class="btn ms-3" (click)="statusData(statusValue)">
                Save
              </button>
              }@else {
              @if(statussetdata){
              <p class="enter-status mb-0">{{ statussetdata }}</p>
              }@else if(profileUserData?.status) {
              <p class="enter-status mb-0">{{ profileUserData?.status }}</p>
              }@else{
              <p class="enter-status mb-0">Enter a Status here</p>
              }
              <i class="fa fa-light fa-pen-to-square ms-3" (click)="statusinput()" style="
                  color: var(--font-color);
                  font-size: 15px;
                  cursor: pointer;
                ">
              </i>
              }
            </div>
          </div>
        </div>
        <div class="mt-3 form-background-color p-3">
          <div class="d-flex justify-content-end">
            @if(!profileEditMode){
            <button class="btn" (click)="profileEditshow()" data-toggle="tooltip" data-placement="bottom" title="Edit">
              <i class="fa fa-light fa-pen-to-square ms-2" style="color: var(--font-color)">
              </i>
            </button>
            }@else if(profileEditMode){
            <i class="fa fa-close ms-2" (click)="profileEditCancel()"
              style="color: var(--font-color); font-size: 20px; cursor: pointer">
            </i>
            }
          </div>

          <form [formGroup]="profileform" (ngSubmit)="updateProfileData()">
            <div class="d-flex align-items-center">
              <div class="setting-label mt-2">
                <div class="form-text py-1">
                  <label for="username">Username</label>
                </div>
              </div>
              <div class="setting-userdata py-2 mt-3">
                <div class="d-flex">
                  <p class="m-0" style="color: var(--default-font-color)">
                    {{ profileUserData?.username }}
                  </p>
                  <small role="button" style="color: var(--font-color)" class="mb-0 ms-2"
                    (click)="selectedTab = 'usernamechanges'">
                    <i class="fa fa-light fa-pen-to-square ms-2" style="color: var(--font-color)">
                    </i></small>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="setting-label">
                <div class="form-text py-1">
                  <label for="fname">First name</label>
                </div>
              </div>
              <div class="setting-userdata py-2 mt-3">
                @if(profileEditMode){
                <input type="text" class="form-control statusinput" id="firstname" placeholder="Enter First Name"
                  formControlName="firstname" maxlength="20" />
                }@else {
                <div>
                  <p class="m-0" style="color: var(--default-font-color)">
                    {{ profilename?.firstname }}
                  </p>
                </div>
                }
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="setting-label">
                <div class="form-text py-1">
                  <label for="lname">Last name</label>
                </div>
              </div>
              <div class="setting-userdata py-2 mt-3">
                @if(profileEditMode){
                <input type="text" class="form-control statusinput" id="lastname" placeholder="Enter Last Name"
                  formControlName="lastname" maxlength="20" />
                }@else {
                <div>
                  <p class="m-0" style="color: var(--default-font-color)">
                    {{ profilename?.lastname }}
                  </p>
                </div>
                }
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="setting-label">
                <div class="form-text py-1">
                  <label for="email">Email Address</label>
                </div>
              </div>
              <div class="setting-userdata py-2 mt-3">
                <div>
                  <p class="m-0" style="color: var(--default-font-color)">
                    {{ profileUserData?.email }}
                  </p>
                </div>
              </div>
            </div>

            <div class="d-flex mt-4">
              @if(profileEditMode){
              <button type="submit" style="
                  border: 1px solid var(--font-color);
                  color: var(--default-font-color);
                " class="btn btn ms-2">
                Save
              </button>
              }
            </div>
          </form>
        </div>
      </div>
      } @if(selectedTab === 'password'){
      <div class="profile-section p-3">
        <div>
          <h4 style="color: var(--default-font-color)" class="">
            Change Password
          </h4>
        </div>

        <div class="form-size mt-4">
          <form class="form" [formGroup]="forgotpassword" (ngSubmit)="forgetPassword(forgotpassword.value)">
            <div class="mb-3">
              <label class="label mb-1" style="color: var(--default-font-color)" for="oldPassword">Old password
              </label>
              <div class="right-inner-addon input-container">
                <i class="fa-solid fa-eye toggle-password" style="color: var(--default-font-color)"
                  (click)="showoldPassword = !showoldPassword" [ngClass]="{
                    'fa-eye': !showoldPassword,
                    'fa-eye-slash': showoldPassword
                  }"></i>
                <input id="oldPassword" [type]="showoldPassword ? 'text' : 'password'" class="form-control statusinput"
                  formControlName="oldPassword" />
              </div>
            </div>

            <div class="mb-3">
              <label class="label mb-1" style="color: var(--default-font-color)" for="newPassword">New password
              </label>
              <div class="right-inner-addon input-container">
                <i class="fa-solid fa-eye toggle-password" style="color: var(--default-font-color)"
                  (click)="showPassword = !showPassword" [ngClass]="{
                    'fa-eye': !showPassword,
                    'fa-eye-slash': showPassword
                  }"></i>
                <input id="newPassword" [type]="showPassword ? 'text' : 'password'" class="form-control statusinput"
                  formControlName="newPassword" />
              </div>
            </div>
            <div class="mb-3">
              <label class="label mb-1" style="color: var(--default-font-color)" for="confirmPassword">confirm New
                password</label>
              <div class="right-inner-addon input-container">
                <i class="fa-solid fa-eye toggle-password" style="color: var(--default-font-color)"
                  (click)="shownewpassword = !shownewpassword" [ngClass]="{
                    'fa-eye': !shownewpassword,
                    'fa-eye-slash': shownewpassword
                  }"></i>
                <input id="confirmPassword" [type]="shownewpassword ? 'text' : 'password'"
                  class="form-control statusinput input-background" [ngClass]="confirmPasswordClass"
                  formControlName="confirmPassword" />
                @if(forgotpassword.hasError('confirmedValidator',
                ['confirmPassword'])){
                <p class="mb-0 text-danger">Passwords do not match</p>
                }
              </div>
            </div>
            <div class="align-items-center">
              <button style="
                  border: 1px solid var(--default-font-color);
                  color: var(--default-font-color);
                " type="submit" [disabled]="forgotpassword.invalid" class="btn">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>

      }

      @if(selectedTab === 'usernamechanges'){
      <div class="profile-section p-3">
        <div>
          <h4 style="color: var(--default-font-color)" class="">
            Change Username
          </h4>
        </div>

        <form class="form" [formGroup]="userNameChangeData" (ngSubmit)="newUsername(userNameChangeData.value)">
          <div class="w-50 mt-4">
            <div class="mb-3">
              <label style="color: var(--default-font-color)" class="label mb-1" for="userName">New username</label>
              <div class="right-inner-addon input-container">
                <input id="userName" type="text" formControlName="username" maxlength="10"
                  class="form-control statusinput" required />
              </div>
            </div>

            <div class="mb-3">
              <label style="color: var(--default-font-color)" class="label mb-1" for="oldPassword">
                Password
              </label>
              <div class="right-inner-addon input-container">
                <i class="fa-solid fa-eye toggle-password" style="color: var(--default-font-color)"
                  (click)="showoldPassword = !showoldPassword" [ngClass]="{
                    'fa-eye': !showoldPassword,
                    'fa-eye-slash': showoldPassword
                  }"></i>
                <input id="password" [type]="showoldPassword ? 'text' : 'password'" class="form-control statusinput"
                  formControlName="password" />
              </div>
            </div>
            <div class="align-items-center">
              <button style="
                  border: 1px solid var(--default-font-color);
                  color: var(--default-font-color);
                " type="submit" class="btn">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
      } @if(selectedTab === 'themes'){

      <div class="profile-section p-3">
        <div>
          <h4 style="color: var(--default-font-colorr)" class="">
            Change Theme
          </h4>
        </div>

        <div class="row board-theme-section">
          <div (click)="switchTheme('morden')" class="card" style="width: 15rem; background-color: #2c3648">
            <div class="card-body">
              <div class="theme-box ms-2">
                <p class="m-0 text-center text-white">
                  <b>Modern</b>
                </p>
              </div>
            </div>
          </div>
          <div (click)="switchTheme('classic')" class="card" style="width: 15rem; background-color: #d2b48c">
            <div class="card-body">
              <div class="theme-box ms-2">
                <p class="m-0 text-center text-white">
                  <b>Classic</b>
                </p>
              </div>
            </div>
          </div>
          <div (click)="switchTheme('dark')" class="card" style="width: 15rem; background-color: #262522">
            <div class="card-body">
              <div class="theme-box ms-2">
                <p class="m-0 text-light text-center">
                  <b>Dark</b>
                </p>
              </div>
            </div>
          </div>
          <div (click)="switchTheme('light')" class="card" style="width: 15rem; background-color: whitesmoke">
            <div class="card-body">
              <div class="theme-box ms-2">
                <p class="m-0 text-center">
                  <b>Light</b>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      } @if(selectedTab === 'board'){
      <div class="profile-section p-3">
        <div>
          <h4 style="color: var(--default-font-colorr)" class="">
            Board & Pieces
          </h4>
        </div>

        <div class="row mt-3">
          <div class="col-sm-5">
            <div class="d-flex justify-content-between align-items-center">
              <label for="">Board</label>
              <select class="form-select w-50 select" [(ngModel)]="selectedtheme"
                (ngModelChange)="borderData(selectedtheme)">
                <option customBox value="Custom" class="option">Custom</option>
                <option value="BI" class="option">Blue Ice</option>
                <option value="Classic" class="option">Classic</option>
                <option value="dr" class="option">Dusty Rose</option>
                <option value="eo" class="option">Electric Oasis</option>
                <option value="Barbie" class="option">Barbie</option>
                <option value="Av" class="option">Aqua Vintage</option>
                <option value="Urban Slate" class="option">Urban Slate</option>
                <option value="Froggy" class="option">Froggy</option>
                <option value="cs" class="option">Coral Sky</option>
                <option value="green" class="option">Green</option>
                <option value="Mint Breeze" class="option">Mint Breeze</option>
                <option value="Cranberry Mist" class="option">
                  Cranberry Mist
                </option>
                <option value="ts" class="option">Tranquil Sky</option>
              </select>
            </div>
            @if(customBox){
            <div class="d-flex justify-content-end my-2">
              <input class="color-input-box" type="color" [(ngModel)]="boardColor" (ngModelChange)="colorchange()" />
              <input class="ms-1 color-input-box" type="color" [(ngModel)]="boardoddColor"
                (ngModelChange)="colorchange()" />
            </div>
            }

            <div class="d-flex justify-content-between align-items-center mt-2">
              <label for="">Piece</label>
              <select class="form-select w-50 select" [(ngModel)]="selectedPiece"
                (ngModelChange)="piecedatas(selectedPiece)">
                <option value="wikipedia" class="option">Wikipedia</option>
                <option value="alpha" class="option">Alpha</option>
                <option value="squart" class="option">Squart</option>
                <option value="forest" class="option">Forest</option>
                <option value="fallout" class="option">Fallout</option>
                <option value="monument" class="option">Monument</option>
                <option value="faded" class="option">Faded</option>
              </select>
            </div>
          </div>

          <div class="col-sm-7 board-top">
            <div class="d-flex justify-content-center">
              <div class="Main-chessBoard">
                <div #boardContainer id="hijk"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      } @if(selectedTab === 'forgetPassword'){
      <div class="profile-section p-3">
        <div>
          @if (changeOTP) {
          <h4 style="color: var(--default-font-color)" class="">OTP</h4>
          <form [formGroup]="confirmOtp" (ngSubmit)="OtpPopups()" action="">
            <div>
              <div class="password-input mb-2">
                <div class="right-inner-addon input-container">
                  <input id="otp" type="text" class="form-control statusinput" formControlName="otp" />
                </div>
              </div>
              <div class="text-end">
                <button class="btn resendOtp-btn" [disabled]="isButtonDisabled" (click)="onResend()">
                  Resend OTP @if(isButtonDisabled){
                  <span> ({{ countdown }})</span>
                  }
                </button>
              </div>
              <button type="button" (click)="OtpPopups()" [disabled]="confirmOtp.invalid"
                class="btn profile-edit-button fw-bold text-uppercase btn-light shadow rounded password-input-save">
                Send
              </button>
            </div>
          </form>
          }@else if(newPasswordsection){
          <h4 class="modal-title text-center mb-2">Enter Your NewPassword</h4>
          <form [formGroup]="newPasswordForm" (ngSubmit)="newpasswordData(newPasswordForm.value)" action="">
            <div>
              <div class="mb-1 forgetpassword-input w-50">
                <div class="inputWithIcon d-flex">
                  <input style="width: 100%" [type]="forgetnewpassword ? 'text' : 'password'"
                    formControlName="forgetPassword" class="form-control statusinput input-mb" id="newPassword"
                    placeholder="new Password" #pw />
                  <i class="fa-solid fa-eye icon-eyes" (click)="forgetnewpassword = !forgetnewpassword" [ngClass]="{
                      'fa-eye': !forgetnewpassword,
                      'fa-eye-slash': forgetnewpassword
                    }"></i>
                </div>
              </div>
              <div class="mb-1 forgetpassword-input w-50">
                <div class="inputWithIcon d-flex">
                  <input id="confirmPassword" [type]="forgetconfirmpassword ? 'text' : 'password'"
                    formControlName="forgetconfirmPassword" class="form-control statusinput input-mb"
                    placeholder="confirm New password" [ngClass]="confirmPasswordClass" #cpw />
                  <i class="fa-solid fa-eye icon-eyes" (click)="forgetconfirmpassword = !forgetconfirmpassword"
                    [ngClass]="{
                      'fa-eye': !forgetconfirmpassword,
                      'fa-eye-slash': forgetconfirmpassword
                    }"></i>
                </div>
                <div *ngIf="
                    forgotpassword.hasError('confirmedValidator', [
                      'confirmPassword'
                    ])
                  ">
                  Passwords do not match
                </div>
              </div>
              <button type="submit" [disabled]="newPasswordForm.invalid"
                class="mt-2 mx-auto btn  fw-bold text-uppercase btn-light shadow rounded">
                Reset password
              </button>
            </div>
          </form>
          } @else {
          <h4 style="color: var(--default-font-color)" class="">
            Forget Password
          </h4>
          <div class="mt-3">
            <p class="m-0 change-password-link" [style.cursor]="loading ? 'default' : 'pointer'"
              (click)="!loading && OtpsendData()">
              {{ loading ? 'Loading...' : 'Change password' }}
            </p>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>